import ACTIONS from "../../constants/actions";

export const filterData = (type, data) => dispatch => {
	dispatch({type : ACTIONS.FILTER.DATA, filterType : type, data : data});
};

export const clearFilter = () => dispatch => {
	dispatch({type : ACTIONS.FILTER.CLEAR});
};




// WEBPACK FOOTER //
// ./src/app/redux/actions/event-filter.js